import './review-declaration.scss'
import { P2TextDescription } from 'react-bootstrap-common-script'
import { TextInfo } from '../../../../text'
import { ApplicationStep1 } from '../../../../../models/classes/ApplicationStep1.class';

interface ReviewDeclarationProps {
  mainApplicantUinfin: string;
  details: ApplicationStep1;
}

const ReviewDeclaration = ({ ...props }: ReviewDeclarationProps) => {
  
  const mainApplicant = props.details.household.owners.find((e) => e.myinfo.uinfin === props.mainApplicantUinfin);
  const mainApplicantInfo = mainApplicant?.myinfo;

  return (
    <div className='polymer-review-declaration'>
      <P2TextDescription
        color="#000"
        title="Declaration and Authorisation"
        size="20px"
      />
      
      <TextInfo variant='row' title={"Name"} titleWeight="700" descWeight="400" description={mainApplicantInfo?.name} />
      <TextInfo variant='row' title={"Email address"} titleWeight="700" descWeight="400" description={mainApplicantInfo?.email} />
      <TextInfo variant='row' title={"Contact number"} titleWeight="700" descWeight="400" description={mainApplicantInfo?.mobile_no} />
    </div>
  )
}

export default ReviewDeclaration